
// util
stockUtil.$inject = ['$window'];
function stockUtil($window) {

    const getDatepickerOptions = (applyHandler) => {
        const daterPickerOptions =
            {
                eventHandlers: {
                    'apply.daterangepicker': applyHandler
                },
                ranges: {
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last 2 Months': [moment().subtract(1, 'month'), moment()],
                    'Last 3 Months': [moment().subtract(3, 'month'), moment()],
                    'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                    'Last 12 Months': [moment().subtract(12, 'month'), moment()]
                },
                locale: {
                    customRangeLabel: ''
                }
            }
        return daterPickerOptions
    }

    const drawGeochart = (chartData, cb) => {
        $window.google.charts.load('upcoming', { 'packages': ['geochart'] });
        $window.google.charts.setOnLoadCallback(drawMarkersMap);

        function drawMarkersMap() {
            var columns = ['Latitude', 'Longitude', 'City', 'Sales (sq. ft.)'];

            let table = [columns];

            _.forEach(chartData, (r) => table.push([r.latitude, r.longitude, r.cidade, r.vendas_sqft]))

            var data = google.visualization.arrayToDataTable(table)

            var options = {
                region: 'US',
                displayMode: 'region',
                resolution: 'provinces',
                colorAxis: {
                    colors: ['#fdce7d', 'orange', 'red', 'darkred']
                }
                , backgroundColor: '#c0d1e8',
                datalessRegionColor: '#eae3d3',
                defaultColor: '#f5f5f5'
            };

            var chart = new $window.google.visualization.GeoChart(angular.element('#chart_div')[0]);
            chart.draw(data, options);
            cb();
        };
    }


    const getOptions = (clickHandler) => {
        return {
            chart: {
                type: 'multiChart', height: 450, margin: { top: 30, right: 60, bottom: 50, left: 70 },
                duration: 500, color: d3.scale.category10().range(),
                showLegend: false,
                // average: function (d) { console.log(d); return d / 18; },
                xAxis: {
                    ticks: 18,
                    axisLabel: 'Time (days)', rotateLabels: -30,
                    tickFormat: function (d) { return d3.time.format("%b %d")(moment(d).utcOffset('-02:00').toDate()); }
                },
                yAxis1: {
                    axisLabel: 'Quantity',
                    tickFormat: function (d) { return d3.format(',.0f')(d); }
                },
                yAxis2: {},
                lines1: {
                    dispatch: {
                        elementClick: clickHandler
                    }
                },
                stack1: { interactive: false }
            }
        };
    };

    const getSalesChartOptions = () => salesChartOptions;

    const salesChartOptions = {
        chart: {
            type: 'linePlusBarChart', height: 450, margin: { top: 30, right: 60, bottom: 50, left: 70 },
            duration: 500, color: d3.scale.category10().range(),
            showLegend: false,
            average: function (d) { console.log(d); return d / 18; },
            xAxis: {
                // ticks: 12,
                axisLabel: 'Time (months)', showMaxMin: false, rotateLabels: -30,
                // tickFormat: function (d) { return d3.time.format("%b %d")(new Date(d)) }
            },
            y1Axis: {
                axisLabel: 'Sales in Sq. Ft', showMaxMin: false,
                tickFormat: function (d) { return d3.format(',.0f')(d); }
            }
        }
    }

    const salesChartOptionsLine = {
        chart: {
            type: 'lineChart', height: 450, margin: { top: 30, right: 60, bottom: 50, left: 70 },
            duration: 500, color: d3.scale.category10().range(),
            showLegend: false,
            useInteractiveGuideline: true,
            average: function (d) { console.log(d); return d / 18; },
            xAxis: {
                // ticks: 12,
                axisLabel: 'Time (months)', showMaxMin: false,
                // tickFormat: function (d) { return d3.time.format("%b %d")(new Date(d)) }
            },
            yAxis: {
                axisLabel: 'Sales in Sq. Ft', showMaxMin: false,
                tickFormat: function (d) { return d3.format(',.0f')(d); }
            }
        }
    }

    const createLine = (values, color, key) => {
        let line = {};
        line.values = values;
        line.type = "line";
        line.key = key;
        line.color = color;
        line.yAxis = 1;
        line.strokeWidth = 2;

        return line;
    }

    const createBar = (stockItem, color) => {
        return {
            values: [
                { x: moment().subtract(1, 'months').toDate(), y: (stockItem.media_vendas * 30) },
                { x: moment().add(3, 'months').toDate(), y: (stockItem.media_vendas * 30) }
            ],
            key: stockItem.nome_material, color: color, type: 'area', yAxis: 1
        }
    }

    const createReferenceLine = (charts, averageSales, daysFromNow, color, isDashed) => {
        const s1Height = _.max(_.map(charts.simulation1, (coord) => coord.y));
        const s2Height = _.max(_.map(charts.simulation2, (coord) => coord.y));
        const s3Height = _.max(_.map(charts.simulation3, (coord) => coord.y));
        const historyHeight = _.max(_.map(charts.history, (coord) => coord.y));
        const salesHeight = averageSales * 30 * 3;

        const height = _.max([s1Height, s2Height, s3Height, historyHeight, salesHeight]);

        const lastStockDate = _.max(_.map(charts.history, (coord) => coord.x))

        return {
            values: [
                { x: moment(lastStockDate).add(daysFromNow, 'days').toDate(), y: 0 },
                { x: moment(lastStockDate).add(daysFromNow, 'days').toDate(), y: height }
            ],
            key: moment().add(daysFromNow, 'days').toDate(), color: color, type: 'line', yAxis: 1, classed: isDashed ? 'dashed-line' : ''
        }
    }

    const createSalesChart = (coords) => {
        let chartData = {};
        chartData.data = [];
        chartData.labels = [];

        chartData.colors = ['#3c8dbc', '#dd4b39'];
        chartData.labels = _.map(coords, (r) => r.mes);
        chartData.data = _.map(coords, month => month.quantidade_sqft)

        return chartData
    }

    const getSalesBehavior = (meanFirstYear, meanSecondYear) => {
        const y1 = _.toNumber(meanFirstYear);
        const y2 = _.toNumber(meanSecondYear);

        let className = '';
        let text = 'Sales ';

        if (y1 < y2) {
            text += 'decreased ';
            className = 'text-red'
        }
        if (y1 > y2) {
            text += 'increased ';
            className = 'text-green'
        }
        if (y1 === 0 && y2 === 0) {
            text = 'No sales record'
            return;
        }

        const rate = Math.abs(_.round(((y1 / y2) - 1) * 100));

        if (_.isFinite(rate)) {
            text += rate + '%';
        } else {
            className = 'text-black'
            text = 'Not enough data to calculate'
        }



        return { text, className };
    }

    const drawRegionalStockChart = (chartData, cb) => {
        $window.google.charts.load('upcoming', { 'packages': ['geochart'] });
        $window.google.charts.setOnLoadCallback(drawMarkersMap);

        function drawMarkersMap() {
            var columns = ['Latitude', 'Longitude', 'City', 'Quantity (sq. ft.)'];

            let table = [columns];

            _.forEach(chartData, (r) => table.push([r.latitude, r.longitude, r.cidade, r.estoque_quantidade]))

            var data = google.visualization.arrayToDataTable(table)

            var options = {
                region: 'US',
                displayMode: 'region',
                resolution: 'provinces',
                colorAxis: {
                    colors: ['#6fa8cc', '#272f71', '#151f73', '#000d75']
                }
                , backgroundColor: '#c0d1e8',
                datalessRegionColor: '#eae3d3',
                defaultColor: '#f5f5f5'
            };

            var chart = new $window.google.visualization.GeoChart(angular.element('#chart_div_stock')[0]);
            chart.draw(data, options);
            cb();
        }
    }

    return {
        getOptions,
        createLine,
        createBar,
        createReferenceLine,
        getDatepickerOptions,
        drawGeochart,
        drawRegionalStockChart,
        createSalesChart,
        getSalesBehavior,
        getSalesChartOptions,
        salesChartOptionsLine
    }
}
app.service('stockUtil', stockUtil);